export const environment = {
  // This should be an ENV var
  // https://github.com/angular/angular-cli/issues/4318
  production: true,
};



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/environments/environment.ts